export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.0.0',
};
//# sourceMappingURL=buildEnv.js.map